import axios from "axios";
import qs from "qs";

const access_token = () =>
  sessionStorage.getItem("token") || "NY_SOEyxfX7RG6Oa2uXRlEeoMWpxgULe";

var instance = axios.create({
  timeout: 1000 * 20,
  withCredentials: true,
});

instance.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = access_token();
    const { params, method, data } = config;
    if (method === "get") {
      config.params = { ...params, access_token: access_token() };
    } else if (method === "post") {
      if (data instanceof FormData) {
        data.append("access_token", access_token());
      } else {
        config.data = qs.stringify({ ...data, access_token: access_token() });
      }
    }

    return config;
  },
  (error) => Promise.error(error)
);

export default instance;
